import { collection, doc, onSnapshot, query, where } from "firebase/firestore"
import { useEffect, useState } from "react"
import { auth, db } from "../firebase"

export function useGetQueue(date) {

    const [queue, setQueue] = useState({
        line: 0,
        queueAt: 0
    })

    useEffect(() => {

        const unsubscribe = onSnapshot(doc(db, "queue", date), {
            next: snapshot => {

                if(snapshot.exists()) {
                    setQueue(snapshot.data())
                } else {
                    setQueue({
                        line: 0,
                        queueAt: 0
                    })
                }

            },
            error: (err) => console.log(err)
        })
         
        return unsubscribe

    }, [date])

    return [queue]

}

export function useMyAppointments(date) {

    const [appointments, setAppointmets] = useState([])

    useEffect(() => {

        if(!auth.currentUser) return () => null

        const q = query(
            collection(db, "appointments"),
            where("user.uid", "==", auth?.currentUser.uid),
            where("DOA", "==", date)  
        )

        const unsubscribe = onSnapshot(q, {
            next: snapshot => {

                let docs = []
                for(const doc of snapshot.docs) {
                    docs.push(doc.data())
                }
                // console.log("all previous")
                setAppointmets(docs.sort((a, b) => a.queuedAt < b.queuedAt))

            },
            error: (err) => console.log(err)
        })

        return unsubscribe

    }, [date])

    const onQueue = appointments.filter(item => !item.status)
    const missed = appointments.filter(item => item.status === "missed")
    const completed = appointments.filter(item => item.status === "completed")

    return { onQueue, missed, completed }

}

export function useGetAllAppointments() {

    const [appointments, setAppointmets] = useState([])

    useEffect(() => {

        if(!auth.currentUser) return () => null

        const q = query(
            collection(db, "appointments"),
            where("user.uid", "==", auth.currentUser.uid),
        )

        const unsubscribe = onSnapshot(q, {
            next: snapshot => {

                let docs = []
                for(const doc of snapshot.docs) {
                    docs.push({
                        ...doc.data(),
                        _id: doc.id
                    })
                }

                setAppointmets(docs)

            },
            error: (err) => console.log(err)
        })

        return unsubscribe

    }, [])

    const onQueue = appointments.filter(item => !item.status)
    const missed = appointments.filter(item => item.status === "missed")
    const completed = appointments.filter(item => item.status === "completed")

    return { onQueue, missed, completed }

}